import AdSlotWithDevSupport from "@bufox/gatsby-utils/fe/google-services/ad-manager/ad-slot-with-dev-support"
import { gamAdUnitByName } from "@bufox/gatsby-utils/fe/google-services/ad-manager/utils"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useWindowDimensions } from "@bufox/react-utils/hooks"
import PropTypes from "prop-types"

const Sticky = ({
  className,
  adUnitName,
  minWidth,
  heights,
  minimizedHeight,
}) => {
  const minHeight = Object.keys(heights)[0]
  const adUnitConfiguration = gamAdUnitByName(adUnitName)
  const { width: windowWidth, height: windowHeight } = useWindowDimensions()
  const currentHeight = () => {
    let output = 0
    for (const [key, value] of Object.entries(heights)) {
      if (key > windowHeight) {
        return output
      }
      if (key <= windowHeight) {
        output = value
      }
    }
    return output
  }
  const [height, setHeight] = useState([currentHeight(), minimizedHeight])
  const [minimized, setMinimized] = useState(false)
  const adjustHeight = () => {
    setHeight(
      minimized
        ? [minimizedHeight, currentHeight()]
        : [currentHeight(), minimizedHeight]
    )
  }

  useEffect(() => {
    adjustHeight()
  }, [windowHeight, minimized])

  const [hideByWidth, setHideByWidth] = useState(windowWidth < minWidth)
  const [hideByHeight, setHideByHeight] = useState(windowHeight < minHeight)

  useEffect(() => {
    setHideByWidth(windowWidth < minWidth)
  }, [windowWidth])
  useEffect(() => {
    setHideByHeight(windowHeight < minHeight)
  }, [windowHeight])

  const minimizeAd = () => {
    setMinimized(!minimized)
    adjustHeight()
  }
  return (
    adUnitConfiguration && (
      <div
        className={className}
        style={{
          height: height[0],
          display: hideByWidth || hideByHeight ? "none" : "block",
        }}
      >
        <div className="ins-ee">
          <svg className="dropdown-svg" onClick={minimizeAd}>
            {minimized ? (
              <>
                <defs>
                  <filter
                    id="dropShadowTop"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feComponentTransfer
                      in="SourceAlpha"
                      result="TransferredAlpha"
                    >
                      <feFuncR type="discrete" tableValues="0.5" />
                      <feFuncG type="discrete" tableValues="0.5" />
                      <feFuncB type="discrete" tableValues="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="TransferredAlpha" stdDeviation={2} />
                    <feOffset dx={0} dy={0} result="offsetblur" />
                    <feMerge>
                      <feMergeNode />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <path
                  d="M0,26 L0,6 A6,6 0 0,1 6,1 L50,1 A6,6 0 0,1 56,6 L56,20 A6,6 0 0,0 62,26 Z"
                  stroke="#FAFAFA"
                  strokeWidth={1}
                  fill="#FAFAFA"
                  style={{ filter: 'url("#dropShadowTop")' }}
                />
                <rect
                  x={0}
                  y={25}
                  width={80}
                  height={5}
                  style={{ fill: "rgb(250, 250, 250)" }}
                />
                <g
                  className="down"
                  stroke="#616161"
                  strokeWidth="2px"
                  strokeLinecap="square"
                >
                  <line x1={22} y1={18} x2={28} y2={12} />
                  <line x1={28} y1={12} x2={34} y2={18} />
                </g>
              </>
            ) : (
              <>
                <defs>
                  <filter
                    id="dropShadowTop"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feComponentTransfer
                      in="SourceAlpha"
                      result="TransferredAlpha"
                    >
                      <feFuncR type="discrete" tableValues="0.5" />
                      <feFuncG type="discrete" tableValues="0.5" />
                      <feFuncB type="discrete" tableValues="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="TransferredAlpha" stdDeviation={2} />
                    <feOffset dx={0} dy={0} result="offsetblur" />
                    <feMerge>
                      <feMergeNode />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <path
                  d="M0,26 L0,6 A6,6 0 0,1 6,1 L50,1 A6,6 0 0,1 56,6 L56,20 A6,6 0 0,0 62,26 Z"
                  stroke="#FAFAFA"
                  strokeWidth={1}
                  fill="#FAFAFA"
                  style={{ filter: 'url("#dropShadowTop")' }}
                />
                <rect
                  x={0}
                  y={25}
                  width={80}
                  height={5}
                  style={{ fill: "rgb(250, 250, 250)" }}
                />
                <g
                  className="down"
                  stroke="#616161"
                  strokeWidth="2px"
                  strokeLinecap="square"
                >
                  <line x1={22} y1={12} x2={28} y2={18} />
                  <line x1={28} y1={18} x2={34} y2={12} />
                </g>
              </>
            )}
          </svg>
        </div>
        <div className="ad-slot">
          <AdSlotWithDevSupport
            className={`inner${minimized ? " minimized" : ""}`}
            // https://react-dfp.surge.sh/examples/basic/
            adSlotId={`ad-slot-sticky`}
            adUnitConfiguration={adUnitConfiguration}
          ></AdSlotWithDevSupport>
        </div>
      </div>
    )
  )
}

Sticky.propTypes = {
  className: PropTypes.string,
  adUnitName: PropTypes.string,
  minWidth: PropTypes.number,
  heights: PropTypes.object,
  minimizedHeight: PropTypes.string,
}

Sticky.defaultProps = {
  heights: { 600: "80px", 1000: "120px" },
  minimizedHeight: "10px",
  minWidth: 300,
}

const StyledSticky = styled(Sticky)`
  width: 100vw;
  transition: height;
  position: fixed;
  bottom: 0;
  background-color: rgb(249, 249, 249);
  z-index: 100;
  transition: height 0.5s;

  .ad-slot {
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: hidden;
    opacity: 1;
    .inner {
      opacity: 1;
      transition: opacity 0.5s;
      &.minimized {
        opacity: 0;
      }
    }
  }

  .ins-ee {
    height: 1px;
    /* background-color: rgb(249, 249, 249); */
    position: relative;
    border-top: 2px solid var(--gray2);
    box-shadow: 0 -2px 5px var(--gray3);
  }

  .dropdown-svg {
    margin: 0px;
    position: absolute;
    top: -25px;
    left: 0;
    display: block;
    width: 80px;
    height: 30px;
    transform: none;
    pointer-events: "initial";
  }
`
export { Sticky }
export default StyledSticky
